export const content = {
  AUTHENTICATING: 'Authentifizierung läuft...',
  ACCOUNT_AUTHORIZATION_ERROR:
    'Prüfe bitte mit der Haufe-IT, ob dein Microsoft-Account dazu berechtigt ist, auf VIVA zuzugreifen.',
  INITIAL_CONNECTION_TIMEOUT:
    'Es dauert ungewöhnlich lange, um eine Antwort zu erhalten. Bist du mit dem Haufe-VPN verbunden?',
  SERVER_ERROR: 'Ein Backend-Fehler ist aufgetreten. Versuche, neu zu laden, oder wende dich ans Team VAMOS.',
  LOADING: 'Wird geladen...',
};
